const startIOSApp = () => {
  window.location.href = 'https://www.bigizone.co.il/redirects/appstore_redirect.html';
}
export default startIOSApp;


// WEBPACK FOOTER //
// ./src/js/lib/startiosapp.js